import
{
    useModifySystemPermissions,
    useSystem,
    useSystemPermissions
} from "../../../ReactData/system";

import { permissionAllowed, SystemPermissions, SystemType } from "@ews/react-data";
import { useL10n } from "@ews/react-localization-context";
import { IonButton } from "@ionic/react";
import { MAX_DEVICE_NUMBER } from "../../../../utils";
import { useDialog } from "../../../Dialog";
import { useMyPermissions } from "../../../Login/LoginProvider";
import { useInvokeUpdateSystemShareOperate } from "../../../ReactData/rpc";
import SettingsCol from "../../../Settings/SettingsCol/SettingsCol";
import SettingsCheckbox from "../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox";
import SettingsNumberInput from "../../../Settings/SettingsComponents/SettingsNumberInput/SettingsNumberInput";
import SettingsSelect from "../../../Settings/SettingsComponents/SettingsSelect/SettingsSelect";
import SettingsSelectOption from "../../../Settings/SettingsComponents/SettingsSelectOption/SettingsSelectOption";
import SettingsTextInput from "../../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";
import { TooltipIcon } from "../../../ToolTip/useTooltip";
import { PermissionsSettingsProps } from "./types";

const PermissionsSettings: React.FC<PermissionsSettingsProps> = ({ systemId }) =>
{
    const system = useSystem(systemId);
    const isBC216 = system.systemType === SystemType.BC216;

    const permission = useSystemPermissions(systemId);
    const myPermissions = useMyPermissions();

    const allowedToEdit = permissionAllowed(myPermissions.grantSystemAccess || 0);

    const modifySystemPermissions = useModifySystemPermissions();
    const dialog = useDialog();
    const { translate: t } = useL10n();
    const invokeUpdateSystemShareOperate = useInvokeUpdateSystemShareOperate();

    function saveSystemPermission(key: keyof SystemPermissions, value: any)
    {
        modifySystemPermissions(system.id!, { [key]: value } as SystemPermissions);
    };

    function applyPermissionsToAllShares()
    {
        invokeUpdateSystemShareOperate({ systemId });
    }

    // const [systemPermissionState, setSystemPermissionState] = useState<Partial<SystemPermissions>>({} as SystemPermissions);

    // useEffect(() =>
    // {
    //     if (!systemPermissionState.systemId && permission.systemId) {
    //         setSystemPermissionState(permission);
    //     }
    // }, [system, permission]);

    return <>
        <SettingsCol >
            <SettingsNumberInput
                disabled={!allowedToEdit}
                lines="none"
                min={0}
                max={180}
                text={"[REACT_SAVE_POSITION_DATA_FOR_(MIN)]"}
                tooltip={<TooltipIcon text={t("COM_FACPMANAGEMENT_FACP_KEEP_POSITION_DESC")} />}
                value={permission.bufferGPSInAreaTime || 0}
                onChange={(bufferGPSInAreaTime) =>
                {
                    let value = bufferGPSInAreaTime;

                    const maxBufferTime = 180;
                    const minBufferTime = 0;


                    if (value > maxBufferTime) {
                        value = maxBufferTime;
                    }

                    if (value < minBufferTime) {
                        value = minBufferTime;
                    }
                    saveSystemPermission("bufferGPSInAreaTime", value);
                    //setSystemPermissionState({ ...systemPermissionState, bufferGPSInAreaTime: value } as SystemPermissions);
                }} />
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_FACP_WLAN"}
                checked={permission.restrictOperationToWlanSSID || false}
                onChange={(restrictOperationToWlanSSID) =>
                {
                    //setSystemPermissionState({ ...systemPermissionState, restrictOperationToWlanSSID } as SystemPermissions);
                    saveSystemPermission("restrictOperationToWlanSSID", restrictOperationToWlanSSID);
                }}>
                <SettingsTextInput
                    disabled={!allowedToEdit}
                    lines="none"
                    text={"COM_FACPMANAGEMENT_FACP_SSID"}
                    value={permission.WlanSSID}
                    onChange={(value) =>
                    {
                        //if (permission.WlanSSID === value) return;
                        //setSystemPermissionState({ ...systemPermissionState, WlanSSID: value } as SystemPermissions);
                        saveSystemPermission("WlanSSID", value);
                    }} />
            </SettingsCheckbox>

            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_FACP_GPS"}
                checked={permission.restrictOperationToGPSArea || false}
                onChange={(restrictOperationToGPSArea) =>
                {
                    //setSystemPermissionState({ ...systemPermissionState, restrictOperationToGPSArea } as SystemPermissions);
                    saveSystemPermission("restrictOperationToGPSArea", restrictOperationToGPSArea);
                }} />
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_FACP_SINGLEUSERINAUTHORIZATION"}
                tooltip={<TooltipIcon text={t("COM_FACPMANAGEMENT_FACP_SINGLEUSERINAUTHORIZATION_DESC")} />}
                checked={permission.exclusiveAuthorization || false}
                onChange={(exclusiveAuthorization) =>
                {
                    //setSystemPermissionState({ ...systemPermissionState, exclusiveAuthorization } as SystemPermissions);
                    saveSystemPermission("exclusiveAuthorization", exclusiveAuthorization);
                }} />
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_FACP_USEIFFACPISINAUTHORIZATION"}
                checked={permission.restrictOperationToAuthorizedUsers || false}
                onChange={(restrictOperationToAuthorizedUsers) =>
                {
                    //setSystemPermissionState({ ...systemPermissionState, restrictOperationToAuthorizedUsers } as SystemPermissions);
                    saveSystemPermission("restrictOperationToAuthorizedUsers", restrictOperationToAuthorizedUsers);
                }} />
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_FACP_USEIFACCESSISENABLED"}
                checked={permission.restrictOperationToApprovedSession || false}
                onChange={(restrictOperationToApprovedSession) =>
                {
                    //setSystemPermissionState({ ...systemPermissionState, restrictOperationToApprovedSession } as SystemPermissions);
                    saveSystemPermission("restrictOperationToApprovedSession", restrictOperationToApprovedSession);
                }} />

            <IonButton
                disabled={allowedToEdit ? !permissionAllowed(myPermissions.createShare || 0) : true}
                expand="full"
                onClick={async () =>
                {
                    const confirm = await dialog({
                        title: t('[REACT_APPLY_SETTINGS_TO_ALL_SHARES]'),
                        message: t('COM_FACPMANAGEMENT_SHARE_CHECK_PERMISSION_CHANGE'),
                        confirmButtonTitle: t('[SID_YES]'),
                        cancelButtonTitle: t('COM_BANNERS_CANCEL')
                    });
                    console.log(confirm);
                    if (confirm) {
                        applyPermissionsToAllShares();

                        // alte "russische" Loesung
                        // saveSystemPermission("applyPermissionsToAllShares", !permission.applyPermissionsToAllShares);
                    }
                }
                }
            >{t('[REACT_APPLY_SETTINGS_TO_ALL_SHARES]')}</IonButton>

        </SettingsCol>

        <SettingsCol >

            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_FACP_APP_FIELD_SUMMER"}
                checked={permission.exposeInternalBuzzer || false}
                onChange={(exposeInternalBuzzer) =>
                {
                    //setSystemPermissionState({ ...systemPermissionState, exposeInternalBuzzer } as SystemPermissions);
                    saveSystemPermission("exposeInternalBuzzer", exposeInternalBuzzer);
                }} />

            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_FACP_APP_FIELD_AE"}
                checked={permission.exposeAlarmingDevice || false}
                onChange={(exposeAlarmingDevice) =>
                {
                    //setSystemPermissionState({ ...systemPermissionState, exposeAlarmingDevice } as SystemPermissions);
                    saveSystemPermission("exposeAlarmingDevice", exposeAlarmingDevice);
                }} >

                <SettingsNumberInput
                    disabled={!allowedToEdit}
                    lines="none"
                    text={"COM_FACPMANAGEMENT_FACP_APP_FIELD_NR"}
                    value={permission.alarmingDeviceFirstElement || 1}
                    onChange={(value) =>
                    {
                        //setSystemPermissionState({ ...systemPermissionState, alarmingDeviceFirstElement: value } as SystemPermissions);
                        saveSystemPermission("alarmingDeviceFirstElement", value);
                    }} />

                {!isBC216 && <SettingsNumberInput
                    disabled={!allowedToEdit}
                    lines="none"
                    text={"COM_FACPMANAGEMENT_FACP_APP_FIELD_TO"}
                    endText=".:"
                    value={permission.alarmingDeviceLastElement || MAX_DEVICE_NUMBER}
                    onChange={(value) =>
                    {
                        //setSystemPermissionState({ ...systemPermissionState, alarmingDeviceLastElement: value } as SystemPermissions);
                        saveSystemPermission("alarmingDeviceLastElement", value);
                    }} />}

                <SettingsSelect
                    disabled={!allowedToEdit}
                    text={"COM_FACPMANAGEMENT_FACP_APP_FIELD_AE_BE"}
                    value={permission.operateAeAuthLevel}
                    onSelect={(value) =>
                    {
                        //setSystemPermissionState({ ...systemPermissionState, operateAeAuthLevel: value } as SystemPermissions);
                        saveSystemPermission("operateAeAuthLevel", value);
                    }}
                >
                    <SettingsSelectOption text={"[REACT_LEVEL_1]"} value={"level1"} />
                    <SettingsSelectOption text={"[REACT_LEVEL_2/3]"} value={"level2"} />

                </SettingsSelect>

            </SettingsCheckbox>

            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_FACP_APP_FIELD_UE"}
                checked={permission.exposeTransmittingDevice || false}
                onChange={(exposeTransmittingDevice) =>
                {
                    //setSystemPermissionState({ ...systemPermissionState, exposeTransmittingDevice } as SystemPermissions);
                    saveSystemPermission("exposeTransmittingDevice", exposeTransmittingDevice);
                }}>

                <SettingsNumberInput
                    disabled={!allowedToEdit}
                    lines="none"
                    text={"COM_FACPMANAGEMENT_FACP_APP_FIELD_NR"}
                    value={permission.transmittingDeviceElement || 1}
                    onChange={(value) =>
                    {
                        saveSystemPermission("transmittingDeviceElement", value);
                    }} />

                <SettingsNumberInput
                    disabled={true}
                    lines="none"
                    text={"[REACT_REACTION_TIMER_(S)]"}
                    value={permission.transmittingDeviceReactionTimer || 0}
                />

                <SettingsNumberInput
                    disabled={true}
                    lines="none"
                    text={"[REACT_EXPLORATION_TIMER_(S)]"}
                    value={permission.transmittingDeviceExplorationTimer || 0}
                />

            </SettingsCheckbox>
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_FACP_APP_FIELD_RESET"}
                checked={permission.exposePanelReset || false}
                onChange={(exposePanelReset) =>
                {
                    //setSystemPermissionState({ ...systemPermissionState, exposePanelReset });
                    saveSystemPermission("exposePanelReset", exposePanelReset);
                }} />
        </SettingsCol>
        <SettingsCol >
            <></>
        </SettingsCol>
    </>;
};

export default PermissionsSettings;